import { auth, db } from '../firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

// Tracks whether a signed-in user has been through the new-user
// walkthrough. Mirrors the mobile app's WalkthroughService — the status is
// synced to Firestore (users/{uid}.walkthroughStatus) so it isn't shown
// again after a different device/browser, with a local localStorage flag as
// a fast/offline-first check on this device.
const SEEN_KEY_PREFIX = 'walkthrough_seen';

// Scoped per-uid so a different account signing in on the same browser
// isn't falsely treated as having already seen the walkthrough.
function seenKey(uid) {
  return uid ? `${SEEN_KEY_PREFIX}_${uid}` : SEEN_KEY_PREFIX;
}

export async function hasSeenWalkthrough() {
  const uid = auth?.currentUser?.uid;
  if (localStorage.getItem(seenKey(uid)) === '1') return true;
  if (!uid || !db) return false;
  try {
    const snap = await getDoc(doc(db, 'users', uid));
    const status = snap.data()?.walkthroughStatus?.status;
    const seen = status === 'completed' || status === 'skipped';
    if (seen) localStorage.setItem(seenKey(uid), '1');
    return seen;
  } catch (error) {
    console.warn('walkthrough: Firestore read failed', error);
    return false;
  }
}

export async function markWalkthroughSeen(status) {
  const uid = auth?.currentUser?.uid;
  localStorage.setItem(seenKey(uid), '1');
  if (!uid || !db) return;
  try {
    await setDoc(doc(db, 'users', uid), {
      walkthroughStatus: { status, updatedAt: serverTimestamp() },
    }, { merge: true });
  } catch (error) {
    console.warn('walkthrough: Firestore sync failed', error);
  }
}
